/* QA: dock OrderHub's existing WhatsApp link beside the mobile Add to cart button.
   Preserve its original href and tracking, and restore the widget on desktop. */
(() => {
  'use strict';
  const ROOT_ID = 'orderhub-whatsapp-chat-root';
  const BAR_ID = 'shoppingooo-purchase-bar';
  let queued = false;

  function sync() {
    const root = document.getElementById(ROOT_ID);
    const bar = document.getElementById(BAR_ID);
    const actions = bar?.querySelector('.shoppingooo-sticky-actions');
    const link = root?.querySelector('a.orderhub-wa-chat') ||
      actions?.querySelector('a.orderhub-wa-chat');
    if (!root || !link) return;

    const egyptProduct = Boolean(
      document.querySelector('main product-info') &&
      location.hostname !== 'iq.shoppingooo.com' &&
      !document.documentElement.classList.contains('shoppingooo-iraq-page') &&
      !document.querySelector('.shoppingooo-iraq-variant-picker')
    );
    const dock = window.innerWidth < 750 && egyptProduct && Boolean(actions);
    const destination = dock ? actions : root;
    if (link.parentElement !== destination) destination.appendChild(link);
    link.toggleAttribute('data-shoppingooo-wa-docked', dock);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      sync();
    });
  }

  function start() {
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, {
      childList: true, subtree: true
    });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('product-info:loaded', schedule);
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else start();
})();